import { useCallback } from 'react';
import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import { EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { GET_BULK_ENROLLMENT_INFO } from 'flow-doctor-lib/queries/EnrollmentQueries';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import { formatTimestampToPortalTz } from 'flow-doctor-lib/utils/dateTimeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BulkEnrollmentInfo = ({
  portalId,
  bulkProcessingId
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(GET_BULK_ENROLLMENT_INFO, {
    variables: {
      portalId,
      bulkProcessingId
    }
  });
  if (error) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "warning"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.viewBulkProcessing.error",
        useGap: true
      })]
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "xs"
    });
  }
  const bulkProcessingRecord = data.bulkEnrollmentInfo;
  return /*#__PURE__*/_jsxs(UIList, {
    styled: true,
    className: "p-left-2 m-bottom-0",
    children: [bulkProcessingRecord.startTime && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.viewBulkProcessing.started",
        options: {
          startTime: formatTimestampToPortalTz(bulkProcessingRecord.startTime)
        }
      })
    }), bulkProcessingRecord.finishTime && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.viewBulkProcessing.completed",
        options: {
          endTime: formatTimestampToPortalTz(bulkProcessingRecord.finishTime)
        }
      })
    }), bulkProcessingRecord.size && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.viewBulkProcessing.oneOfRecords",
        options: {
          count: bulkProcessingRecord.size
        }
      })
    }), bulkProcessingRecord.userId && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.viewBulkProcessing.createdBy"
      }), /*#__PURE__*/_jsx(UserNameLabel, {
        userId: bulkProcessingRecord.userId
      })]
    })]
  });
};
const FlowBulkEnrollmentInfoIcon = ({
  portalId,
  bulkProcessingId
}) => {
  const WrappedBulkProcessingInfo = useCallback(() => /*#__PURE__*/_jsx(BulkEnrollmentInfo, {
    portalId: portalId,
    bulkProcessingId: bulkProcessingId
  }), [portalId, bulkProcessingId]);
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: WrappedBulkProcessingInfo,
    maxInlineSize: "300",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "info",
      size: 14,
      color: EERIE
    })
  });
};
export default FlowBulkEnrollmentInfoIcon;